export const MAX_ZINDEX = 9999;
